import MEMBER from "./MEMBER";
import OBSERVER from "./OBSERVER";

export default { MEMBER, OBSERVER };
